require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./apis-and-microservices-basic-node-and-express-start-a-working-express-server.json") })
        }
      }, "path---apis-and-microservices-basic-node-and-express-start-a-working-express-server");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---apis-and-microservices-basic-node-and-express-start-a-working-express-server!./.cache/json/apis-and-microservices-basic-node-and-express-start-a-working-express-server.json
// module id = 1271
// module chunks = 231608221292675